import { Deserializable } from '../deserializable';
import { UserFiaPins } from '../users/user-fia-pins';

export class NewTransaction implements Deserializable {
  public arbFacilitatorId: number;
  public brokerId: number;
  public userId: number;
  public createdByUserId: number;
  public tradeAmount: number = 0;
  public tradeAmountCurrencyId: number;
  public userFiaPins: UserFiaPins[] = [];
  public fiaAmount: number = 0;
  public sdaAmount: number = 0;

  public overrideAccountBalance: boolean = false;
  public overriddenAccountBalance: number;

  public fullName: string;
  public success: boolean;
  public message: string;

  public billingType: number = 2; // Default Premium (2)
  public selectedBillingType: number = 0;

  public overridePips: boolean = false;
  public pips: number;

  public transactionStartDate: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
